<template>
  <div style="width:100%">

  <div class="header-main ">
    <div class="hm-left ">
      <div>
        <div class="bread-crumb"></div>
        <div class="header-main__title-wrap">
          <h1 class="header-main__title">Товары </h1>
          <div class="header-main__review"></div>
        </div>
      </div>
    </div>

    <div class="hm-right">
      <div class="btn-wrapper btn-wrapper_group new">

         <router-link to="/timesellers" class="btn_ms m0 btn" v-if="$store.state.user.id === 307">
          <div >Время работы продавцов</div>
        </router-link> 

        <router-link to="/tasksto" class="btn_ms m0 btn" v-if="$store.state.user.id === 14">
          <div class="">Задачи</div>
        </router-link>
        <router-link to="/sto" class="btn_ms m0 btn" v-if="$store.state.user.id === 14">
          <div class="">Посты</div>
        </router-link>
        <router-link to="/bonus" class="btn_ms btn ">
          <div class="">Бонусы</div>
        </router-link>
        
        <router-link to="/alltask" class="btn_ms m0 btn btntask">
          <div class="">Задачи</div>
        </router-link>

      <router-link to="/orders" class="btn_ms m0 btn">
          <div class="">Заказы</div>
        </router-link>

        <router-link v-if="isRukovodstvoRole" to="/retailcrm-moysklad-report" class="btn_ms m0 btn">
          <div class="">Сверка RC / МС</div>
        </router-link>

        <router-link v-if="isRukovodstvoRole" to="/kassa-after-redirect" class="btn_ms m0 btn">
          <div class="">Касса после доставки</div>
        </router-link>

        <router-link v-if="isRukovodstvoRole" to="/kassa-30-days" class="btn_ms m0 btn">
          <div class="">Кассы за 30 дней</div>
        </router-link>

        <router-link to="/karvata-dovoz" class="btn_ms m0 btn">
          <div class="">Довоз с Карваты</div>
        </router-link>

        <div class="btn_md m0 btn" :class="{ disabled: hasSavedOrders }"
    :disabled="hasSavedOrders">
          <div class="btn-content btn-content_icon btn-content_new" @click="newOrder">Новый заказ</div>
        
        </div>
                        
      </div>
    </div>
  </div>


    <!-- Модальное окно -->
    <div v-if="isModalVisible" class="modal-overlay" @click.self="closeModal">
      <div class="modal-content">
        
        <button @click="closeModal" class="close-btn">Закрыть</button>
      </div>
    </div>

    

    <div class="flex-podbor">
    
       

      <div class="main-content" style="position: relative;">
        <label>Подбор по марке авто</label>
        <!-- Подключаем компонент CarSelector -->
        <car-selector compact ref="carSelector" @update-corpus="updateCorpus" @update-link="updateCorpusLink"></car-selector>
         <div style="display: flex;
align-items: center;
gap: 12px;

position: absolute;
bottom: 23px;
right: 0;
left: 147px;">
        <button
          v-if="hasPopularBatteries"
          class="btn-show-batteries"
          @click="showModalPodborProduct = true"
        >
          Продавались на этот авто
        </button>

        <div v-if="loadingPopularBatteries" class="spinner_podbor"></div>
      </div>
      </div>
     

      <form id="resetForm">
        <div class="reset_block_two">
          <label>Наименование:</label>
          <input class="border border-gray-200" type="text" v-model="keyword" placeholder="Наименование:" />
        </div>

        <div class="reset_block">
          <label>Категория:</label>
          <div>
            <TreeSelect
              :multiple="true"
              :options="nameCategory"
              :disable-branch-nodes="true"
              placeholder="Выберите категорию"
              v-model="namekat"
              search-nested
            />
          </div>
        </div>
        <div class="reset_block">
          <label>Цена:</label>
          <div class="input_flex">
            <input class="border border-gray-200" type="text" v-model="priceFrom" placeholder="От">
            <span> - </span>
            <input class="border border-gray-200" type="text" v-model="priceTo" placeholder="До">
          </div>
        </div>

        <div class="reset_block">
          <label>Длинна:</label>
          <div class="input_flex">
            <input class="border border-gray-200" type="text" v-model="lengthFrom" placeholder="От">
            <span> - </span>
            <input class="border border-gray-200" type="text" v-model="lengthTo" placeholder="До">
          </div>
        </div>

        <div class="reset_block">
          <label>Ширина:</label>
          <div class="input_flex">
            <input class="border border-gray-200" type="text" v-model="widthFrom" placeholder="От">
            <span> - </span>
            <input class="border border-gray-200" type="text" v-model="widthTo" placeholder="До">
          </div>
        </div>

        <div class="reset_block">
          <label>Высота:</label>
          <div class="input_flex">
            <input class="border border-gray-200" type="text" v-model="heightFrom" placeholder="От">
            <span> - </span>
            <input class="border border-gray-200" type="text" v-model="heightTo" placeholder="До">
          </div>
        </div>

        <div class="reset_block">
          <label>Емкость:</label>
          <div class="input_flex">
            <input class="border border-gray-200" type="text" v-model="capacityFrom" placeholder="От">
            <span> - </span>
            <input class="border border-gray-200" type="text" v-model="capacityTo" placeholder="До">
          </div>
        </div>

        <div class="reset_block">
          <label>Ценовая категория:</label>
          <TreeSelect
            :multiple="true"
            :options="priceCategoryes"
            placeholder="Выберите ценовую категорию"
            v-model="pricekat"
            search-nested
          />
        </div>

        <div class="reset_block">
          <label>Полярность:</label>
          <TreeSelect
            :multiple="true"
            :options="sizeFilter"
            placeholder="Выберите полярность"
            v-model="sizes"
            search-nested
          />
        </div>

        <div class="reset_block">
          <label>Склады:</label>
          <TreeSelect
            :multiple="true"
            :options="categoryFilters"
            placeholder="Выберите склад"
            v-model="categories"
            search-nested
          />
        </div>

        <div class="reset_block">
          <label>Тип корпуса:</label>
          <TreeSelect
            :multiple="true"
            :options="corpusFilter"
            placeholder="Выберите тип корпуса"
            v-model="corpus"
            :disable-branch-nodes="true"
            search-nested
          />
        </div>

        <div class="reset_block">
          <label>Бренд:</label>
          <TreeSelect
            :multiple="true"
            :options="brendFilters"
            placeholder="Выберите производителя"
            v-model="brends"
            search-nested
          />
        </div>

        <div class="reset_block">
          <label>Вязкость:</label>
          <TreeSelect
            :multiple="true"
            :options="vyzkostFilter"
            placeholder="Вязкость масла"
            v-model="vyzkostf"
            search-nested
          />
        </div>
        <div class="button_filter_block">
        <button @click.prevent="applyFilters" class="apply text"><span v-if="isLoadingMore" class="spinner"></span><span>Применить фильтры</span></button>
        <span v-if="filtersApplied" class="filter-cancel" @click="resetFilters"><span class="ur-hr-no">Сброс</span></span>
        </div>
      </form>
     <div class="checkbox-wrapper">
      <div class="chek_left">
      <input type="checkbox" id="competitorCheckbox" v-model="showCompetitors" class="switch"/>
      <label for="competitorCheckbox">Показать конкурентов</label>
      </div>
  <div class="check_right">
  <!-- Чекбокс "Минск" -->
   <input type="checkbox" id="karvataCheckbox" v-model="karvataChecked" @change="selectStores('karvata')" class="switch" />
  <label for="karvataCheckbox">Карвата</label>


  <input type="checkbox" id="minskCheckbox" v-model="minskChecked" @change="selectStores('minsk')" class="switch" />
  <label for="minskCheckbox">Минск</label>

  <!-- Чекбокс "Наши склады" -->
  <input type="checkbox" id="ourStoresCheckbox" v-model="ourStoresChecked" @change="selectStores('ourStores')" class="switch" />
  <label for="ourStoresCheckbox">Наши склады</label>

  <input type="checkbox" id="vputiCheckbox" v-model="vputiChecked" @change="selectStores('vputi')" class="switch" />
  <label for="vputiCheckbox">В пути</label>

  <!-- Чекбокс "Поставщики" -->
  <input type="checkbox" id="suppliersCheckbox" v-model="suppliersChecked" @change="selectStores('suppliers')" class="switch" />
  <label for="suppliersCheckbox">Все</label>

    <!-- Чекбокс "Все товары нухуй" -->

</div>


 <div class="items-per-page-selector">
      <label for="itemsPerPage">Показывать по:</label>
      <select id="itemsPerPage" v-model="perPage" @change="updateItemsPerPage">
        <option value="30">30</option>
        <option value="50">50</option>  
        <option value="100">100</option>
      </select>
    </div>
</div>
</div>

   


    <p style="text-align: right;
    font-weight: 600;">Найдено {{this.totalRows }} элемента</p>
    <div v-if="localLoading" class="loader-container">
        <div class="spinner"></div>
      </div>
      <div v-else class="product-list">
    <!-- Таблица продуктов -->
    <div class="table-wrapper" ref="tableWrapper">
    <table class="modern-table list js-order-list batch-tbl">
      <thead>
        <tr>
          <th width="50" style="text-align: center;">Фото</th>
          <th width="400" @click="sort('residues')">Наименование</th>
          <th></th>
          <th></th>
          <th width="50" @click="sort('tok')">Пуск. ток</th>
          <th width="15" @click="sort('emkost')">Емкость</th>
          <th width="90">Дата выпуска</th>
         
          <th width="300"   @click="sort('residues')" v-if="getFilteredCategories().includes('m')">Наличие у нас</th>
          <th width="180" v-if="getFilteredCategories().includes('m-2')">Наличие у поставщиков (бонус)</th>
          
          <th @click="sort('price')" style="width: 50px;">Цена (руб.)</th>
          <th @click="sort('seba')" style="width: 50px;">Бонус</th>
    <th v-if="showCompetitors">onliner.by</th>
    <th v-if="showCompetitors">21vek.by</th>
    <th v-if="showCompetitors">1ak.by</th>
    <th v-if="showCompetitors">стиген</th>
    <th v-if="showCompetitors">akb-rimbat</th>
    <th v-if="showCompetitors">БАТАВТОТРЕЙД</th>
          <th></th>
    <!--<th style="width: 60px;">Количество</th>-->
        </tr>
      </thead>
      <tbody v-if="computedProducts.length > 0">
  <tr v-for="(product, index) in computedProducts" :key="index" :class="{ 'in-order': isProductInOrder(product.id) }" :ref="product.id === lastAddedProductId ? 'lastAddedProductRow' : null">
    <td style="text-align: center;"><img :src="product.jpg_url" /></td>
    <td style="position:relative;"><a :href="product.href" target="_blank">{{ product.name }}</a><span style="display:none">{{ product.artikul }}</span>
      <div class="property" style="display:none">
        <span v-if="product.korpus">Тип корпуса: {{ product.korpus }}; </span>
        <span v-if="product.length">Габариты: {{ product.length || product.width || product.height ? 
    `${product.length ? product.length : ''}*${product.width ? product.width : ''}*${product.height ? product.height : ''}` 
    : '' }}; </span>
    <span v-if="product.polarka">Полярность: {{ product.polarka }}; </span> 
    <div class="count">{{ product.count }} шт</div>
      </div>
      <span v-if="isProductInOrder(product.id)" class="in-order-label">В заказе</span>
    </td>

    <td>
      <Helper
        :product="product.name"
        :brand="product.brend"
        :category_name="product.category_name"
      /></td>

      <td >
      <!-- Кнопка копирования -->
      <button @click.stop="copyProductName(product.name)" class="copy-btn" style="position: relative;">
        <i class="fa fa-copy">
          <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 2048 2048">
            <path d="M416 0h979v1l31 4 22 6 21 9 16 9 16 12 10 9 13 13 12 16 11 19 9 21 5 18 3 17 1 12v133h129l22 2 15 3 17 5 18 8 18 10 17 13 13 12 10 11 10 14 9 15 7 15 6 17 5 22 2 21v1406l-2 19-4 20-6 18-7 16-13 21-13 16-16 16-19 14-20 11-20 8-15 4-17 3-12 1H711l-21-2-20-5-19-7-16-8-16-10-13-11-11-10-7-8-9-11-12-19-9-19-6-18-4-20-2-20v-129H420l-23-2-20-4-20-7-19-9-11-7-16-12-15-14-7-8-10-13-9-15-8-16-6-16-5-21-2-15-1-26V177l1-18 3-19 6-21 6-15 10-19 12-17 11-12 14-14 15-11 15-9 14-7 24-8 15-3 22-3zm10 94-16 1-13 3-16 8-9 6-8 7-10 13-7 14-4 13-1 6-1 1399 1 16 4 16 8 16 8 11 8 8 13 9 10 5 14 4 8 1 117 1h717l151-1 11-2 12-4 15-8 11-9 8-9 8-13 5-13 2-9 1-10V169l-3-16-5-13-7-12-11-12-8-7-14-8-15-5-5-1-21-1zm1139 298-1 1187-2 19-5 21-7 19-11 21-8 12-11 13-7 8-11 10-17 12-14 8-15 7-18 6-18 4-15 2-44 1H640l-1 1v132l2 11 4 12 7 13 7 9 10 10 12 8 11 5 17 4 13 1h936l42-1 16-4 16-8 10-7 11-11 7-11 6-13 3-11 1-7V465l-3-16-7-16-7-11-13-13-11-7-10-5-13-4-6-1z"></path>
          </svg>
        </i>
        <div v-if="copiedId === product.name" class="tooltips">
        <i class="fa fa-check"></i> Скопировано!
        <div class="tooltips-arrow"></div>
      </div>
      </button>
      <!-- Абсолютно позиционированный тултип, отображается только для заказа с совпадающим id -->
      
    </td>
    <td style="text-align:center;">{{ product.starttok }}</td>
    <td style="text-align:center;">{{ product.emkost }}</td>
    <td class="gtd-cell" style="text-align:center;">
      <span v-if="product.gtd" class="gtd-value" :title="product.gtd">{{ product.gtd }}</span>
      <span v-else class="gtd-empty">—</span>
    </td>

    <!-- Фильтрация склада m через вычисляемое свойство filteredSkladm -->
    <td
    style="min-width: 85px;"
    v-if="getFilteredCategories().includes('m')"
  >
  <div style="display:flex;flex-wrap: wrap;">
    <template v-if="getStoreEntry(product, 'Карвата')">
      <p class="tooltips_blue">
        <span
          class="warehouse-item green-karvata"
        >
          {{ formatStoreLabel(getStoreEntry(product, 'Карвата')) }}
        </span>
      </p>
    </template>

    <template v-for="groupKey in ['minsk', 'regions']">
      <template v-if="hasGroupData(product, groupKey)">
        <p 
          v-if="!isGroupExpanded(product.id, groupKey)"
          class="tooltips_blue" 
          :key="`group-${product.id}-${groupKey}`"
        >
          <span
            class="warehouse-item warehouse-group-toggle"
            :class="{ 'blue-text': groupKey === 'minsk' }"
            @click.stop="toggleWarehouseGroup(product.id, groupKey)"
          >
            {{ getGroupLabel(product, groupKey) }}
          </span>
        </p>
        <div
          v-if="isGroupExpanded(product.id, groupKey)"
          class="warehouse-group-details"
          :key="`details-${product.id}-${groupKey}`"
        >
          <p
            v-for="store in getGroupStores(product, groupKey)"
            :key="`expanded-${product.id}-${groupKey}-${store.id}`"
            class="tooltips_blue"
          >
            <span
              :class="[
                { 'blue-text': isBlueId(store.id) },
                { 'green-karvata': isKarvata(store.id) },
                'warehouse-item'
              ]"
            >
              {{ formatStoreLabel(store) }}
            </span>
          </p>
        </div>
      </template>
    </template>

    <p
      v-for="(m, mIndex) in getRemainingStores(product)"
      :key="`m-${index}-other-${mIndex}`"
      class="tooltips_blue"
    >
      <Tooltip v-if="m.id === 'В пути'" :productId="product.id">
        <i class="icon-truck"></i>
        {{ m.id }}
      </Tooltip>
      <span
        v-else
        :class="[
          { 'blue-text': isBlueId(m.id) },
          { 'green-karvata': isKarvata(m.id) },
          'warehouse-item'
        ]"
      >
        {{ formatStoreLabel(m) }}
      </span>
    </p>
  </div>
  </td>
 <td v-if="getFilteredCategories().includes('m-2')">
      <p v-for="(p, pIndex) in filteredSkladp(product)" :key="`p-${index}-${pIndex}`">
        {{ p.id }}-<span>{{ p.count }}</span>
        <span class="bonus" v-if="p.seba > 0">{{ p.seba }}</span>
        <span class="nobonus" v-else>{{ p.seba }}</span>
      </p>
    </td>

   
    <!-- Условие отображения цены -->
    <td v-if="product.price === ''"></td>
    <td v-else :class="getPriceClass(product)" style="text-align:center;">
      <div class="price-cell">
        <span v-if="product.old_price" class="old-price">{{ product.old_price }} руб.</span>
        <span class="price-current">{{ product.price }} руб.</span>
      </div>
    </td>

    <td style="text-align:center;">{{ product.seba }} </td>
    <td v-if="showCompetitors"><a :href="product.onliner_link" target="_blank">{{ product.onliner }}</a></td>
    <td v-if="showCompetitors"><a :href="product.vek_link" target="_blank">{{ product.vek }}</a></td>
    <td v-if="showCompetitors"><a :href="product.pak_link" target="_blank">{{ product.ak }}</a></td>
    <td v-if="showCompetitors"><a :href="product.stigen_link" target="_blank">{{ product.stigen }}</a></td>
    <td v-if="showCompetitors"><a :href="product.akbrimbat_link" target="_blank">{{ product.rimbat }}</a></td>
    <td v-if="showCompetitors"><a :href="product.hrefbattorg" target="_blank">{{ product.pricebattorg }}</a></td>
    

     <td class="table-td-button" style="text-align:center;">
        <div class="button_quantity" v-if="isProductInOrder(product.id)">
          <button @click.stop="decreaseQuantity(product)" class="qty-btn qty-btn-decrease">-</button>
          <span class="quantity">{{ getQuantity(product) }}</span>
          <button @click.stop="increaseQuantity(product)" class="qty-btn qty-btn-increase">+</button>
        </div>
        <button v-else @click="emitAddProduct(product)" class="add-btn">Добавить</button>
      </td>
  </tr>
  
</tbody>

<tbody v-else>
  <tr>
    <td colspan="18">Ничего не найдено</td>
  </tr>
</tbody>

    </table>

<button
  v-if="showCreateOrderButton || activeOrderProducts.length > 0"
  @click="handleOrderAction()"
  class="create-order-btn"
  :style="{ top: `${buttonPositionTop}px`, left: `${buttonPositionLeft}px` }"
>
  {{ getButtonText() }}
</button>

    </div>
   
    <!-- Пагинация -->
     <div :class="{'fixedPagination': !atPageEnd, 'staticPagination': atPageEnd}">
      
        <b-pagination
          :total-rows="totalRows"
          v-model="currentPage"
          :per-page="perPage"
          @change="handlePageChange"
        ></b-pagination>

      </div>

    </div>

     <PopularBatteriesModal
  :visible="showModalPodborProduct"
  :batteries="popularBatteries"
  :isProductInOrder="isProductInOrder"
  @close="showModalPodborProduct = false"
 
  :managersDict="managers"  
/>

    <!-- Компонент уведомлений -->
    <toast-container></toast-container>




  </div>
</template>

<script>
import { ORDERS_API_BASE } from '@/config/api';
import axios from 'axios';
import Vue from 'vue';
import { Treeselect } from '@riophae/vue-treeselect'; // Импортируем компонент Treeselect
import vSelect from 'vue-select';

import 'vue-select/dist/vue-select.css';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import 'bootstrap/dist/css/bootstrap.css';
import Tooltip from "@/components/Tooltip.vue";
import Helper from "@/components/Helper.vue"

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import CarSelector from './CarSelector.vue';
import { mapState, mapActions, mapGetters } from 'vuex';
import PopularBatteriesModal from '@/components/PopularBatteriesModal.vue';
import { sortManagersByLabel } from '@/constants/sortManagers';
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

// Регистрируем компоненты
Vue.component('TreeSelect', Treeselect); // Регистрируем Treeselect
Vue.component('v-select', vSelect);

export default {
  name: 'MainPage',
  components: {
     'TreeSelect': Treeselect,  // Локальная регистрация компонента для использования в шаблоне
     'car-selector': CarSelector,
     Tooltip,
     PopularBatteriesModal,
     Helper
  },
  data() {
    return {
    filtersApplied: false,
    atPageEnd: false,
    localLoading: true,
    user:'',
      isActive: true,
      order: {},
      categories: [],
      tooltip_blue: false,
      tooltip_blue_map: {},
      minskChecked: false,
      karvataChecked:false,
      copiedId: null,
      showModalPodborProduct:false,
      vputiChecked:false,
      ourStoresChecked: false,
      suppliersChecked: false,
      siteChecked:false,
      selectionLink:'',
      popularBatteries: {
        exact: [],
        similar: [],
        model: []
      },
      loadingPopularBatteries: false,
      showCompetitors: false,
      sortField: undefined,
      lastAddedProductId: null,
      showCreateOrderButton: false,
      buttonPositionTop: 0,
      buttonPositionLeft: 0,
      sortAsc: 1,
      managers:[],
      isLoadingMore: false,
      isModalVisible: false,
      isDataLoaded: false, // Флаг загрузки данных
      currentSort: 'name',
      currentSortDir: 'desc',
      flag: '',
      colors: [],
      warehouseGroupState: {},
      warehouseDisplayGroups: {
        minsk: {
          label: 'Минск',
          stores: ['Володько', 'Машинка', 'Салюты', 'Бельского']
        },
        regions: {
          label: 'Регионы',
          stores: ['Гомель-Ефрем', 'Гомель-Бакун', 'Брест', 'Витебск', 'Полоцк', 'Могилев', 'Барановичи', 'Гродно', 'Новополоцк', 'Бобруйск']
        }
      },
      storeGroups: {
        karvata: ["Карвата"],
        vputi: ["В пути"],
        minsk: ["Карвата", "Салюты", "Володько", "Машинка", "Бельского"],
        ourStores: ["Карвата", "Володько", "Машинка", "Бельского", "Салюты", "Гомель-Ефрем", "Гомель-Бакун", "Брест", "Витебск", "Полоцк", "Могилев", "Барановичи", "Гродно", "Новополоцк", "Бобруйск"],
        suppliers: ["Римбат", "ПАК", "БАТАВТОТРЕЙД", "MOTEX", "АРМТЕК", "ШАТЕ-М", "КИПЕР", "Автоспейс"]
      },
      colorFilter: [],
      sizes: [],
      count: [],
      priceFrom: '',
      priceTo: '',
      lengthFrom: '',
      lengthTo: '',
      widthFrom: '',
      widthTo: '',
      heightFrom: '',
      heightTo: '',
      capacityFrom: '',
      capacityTo: '',
      rangeBoundary0: '',
      rangeBoundary1: '',
      evenOnly: [],
      sizeFilter: ["плюс справа", "плюс слева", "ИБП"].map(i => ({ id: i, label: `${i}` })),
      priceCategory: ["Эконом", "Стандарт", "Премиум", "AGM", "EFB", "ИБП", "GEL (гелевые)"].map(i => ({ id: i, label: `${i}` })),
      nameCategory: ["Аккумуляторы", "Зарядные устройства", "Масла и жидкости", "Шины и диски"].map(i => ({ id: i, label: `${i}` })),
      vyzkostFilter: ["0W-10", "0W-16", "0W-20", "0W-30", "0W-40", "5W-20", "5W-30", "5W-40", "5W-50", "10W-30", "10W-40", "10W-50", "10W-60", "15W-40", "15W-50", "15W-60", "20W-40", "20W-50", "20W-60", "20W", "30W", "40W", "70W-80", "75W", "75W-80", "75W-85", "75W-90", "75W-140", "80W", "80W-85", "80W-90", "80W-140", "85W-90"].map(i => ({ id: i, label: `${i}` })),
      brendFilter: [],
      brends: [],
      vyzkostf: [],
      pricekat: [],
      namekat: [],
      products: [],
      test: ['Эконом', 'Tara', 'Жора'],
      keyword: "",
      keywordl: "",
      keywordw: "",
      keywordh: "",
      keywordk: "",
      currentPage: 1,
      perPage: 30,
      categoryFilter: [ {
          id: 'm',
          label: 'Наши магазины',
          children: [ {
            id: 'Карвата',
            label: "Карвата",
          }, {
            id: "Володько",
            label: "Володько",
          }, {
            id: "Машинка",
            label: "Машинка",
          },
          {
            id: "Бельского",
            label: "Бельского",
          }, {
            id: "Салюты",
            label: "Салюты",
          }, {
            id: "Гомель-Ефрем",
            label: "Гомель, Ефремовский",
          }, {
          id: "Гомель-Бакун",
          label: "Гомель, Бакунинский",
        },{
            id: "Брест",
            label: "Брест",
          }, {
            id: "Витебск", 
            label: "Витебск", 
          }, {
            id: "Полоцк", 
            label: "Полоцк", 
          }, {
            id: "Могилев",
            label: "Могилев",
          }, {
            id: "Барановичи",
            label: "Барановичи",
          }, {
            id: "Гродно",
            label: "Гродно",
          }, {
            id: "Новополоцк",
            label: "Новополоцк",
          }, {
            id: "Бобруйск",
            label: "Бобруйск",
        }, {
            id: "В пути",
            label: "В пути",
        } ],
      }, {
          id: 'm-2',
          label: 'Поставщики',
          children: [ {
            id: "Римбат",
            label: "Римбат",
          }, {
            id: "ПАК",
            label: "ПАК",
          }, {
            id: "БАТАВТОТРЕЙД",
            label: "БАТАВТОТРЕЙД",
          }, {
            id: "MOTEX",
            label: "MOTEX",
          }, {
            id: "АРМТЕК",
            label: "АРМТЕК",
          }, {
            id: "ШАТЕ-М",
            label: "ШАТЕ-М",
          }, {
            id: "КИПЕР",
            label: "КИПЕР",
          }, {
            id: "Л-АВТО",
            label: "Л-АВТО",
          }, {
            id: "Автоспейс",
            label: "Автоспейс",
          } ],
      } ],
      corpus: [],
      brendFilters:[],
      socket: null,
      priceCategoryes: [
           { id: 'ekonom', label: 'Эконом' },
           { id: 'premium', label: 'Премиум' },
           { id: 'standard', label: 'Стандарт' },
           { id: 'efb', label: 'EFB' },
           { id: 'agm', label: 'AGM' },
           { id: 'ibp', label: 'ИБП' },
           
       ],
      corpusFilter: [ {
          id: 'auto',
          label: 'Европейские типы корпусов',
          children: [ {
            id: 'L0',
            label: "L0 - (175x175x190)",
          }, {
            id: "L1",
            label: "L1 - (207x175x190)",
          }, {
            id: "L2",
            label: "L2 - (242x175x190)",
          }, {
            id: "L3",
            label: "L3 - (278x175x190)",
          }, {
            id: "L4",
            label: "L4 - (315x175x190)",
          }, {
            id: "L5",
            label: "L5 - (353x175x190)",
          }, {
            id: "L6", 
            label: "L6 - (393x175x190)", 
          }, {
            id: "LB1", 
            label: "LB1 - (207x175x175)", 
          }, {
            id: "LB2",
            label: "LB2 - (242x175x175)",
            }, {
            id: "LB3",
            label: "LB3 - (278x175x175)",
            }, {
            id: "LB4",
            label: "LB4 - (315x175x175)",
            }, {
            id: "LB5",
            label: "LB5 - (353x175x175)",
            }, {
            id: "LB1L",
            label: "LB1L - (207x175x175)",
            }, {
            id: "LB2L",
            label: "LB2L - (242x175x175)",
            }, {
            id: "LB3L",
            label: "LB3L - (278x175x175)",
            }, {
            id: "LB4L",
            label: "LB4L - (315x175x175)",
            }, {
            id: "LB5L",
            label: "LB5L - (353x175x175)",
            }, {
            id: "L0L",
            label: "L0L - (175x175x190)",
            }, {
            id: "L1L",
            label: "L1L - (207x175x190)",
            }, {
            id: "L2L",
            label: "L2L - (242x175x190)",
            }, {
            id: "L3L",
            label: "L3L - (278x175x190)",
            }, {
            id: "L4L",
            label: "L4L - (315x175x190)",
            }, {
            id: "L5L",
            label: "L5L - (353x175x175)",
        } ],
      }, {
          id: 'aziat',
          label: 'Азиатские типы корпусов',
          children: [ {
            id: "D23",
            label: "D23 - (230x175x225)",
          }, {
            id: "D23L",
            label: "D23L - (230x175x225)",
          }, {
            id: "D26",
            label: "D26 - (260x175x225)",
          }, {
            id: "D26L",
            label: "D26L - (260x175x225)",
          }, {
            id: "D31",
            label: "D31 - (306x175x225)",
          }, {
            id: "D31L",
            label: "D31L - (306x175x225)",
          }, {
            id: "B19",
            label: "B19 - (187х127х225)",
          }, {
            id: "B19L",
            label: "B19L - (187х127х225)",
          }, {
            id: "B24",
            label: "B24 - (238x127x225)",
          }, {
            id: "B24L",
            label: "B24L - (238x127x225)",
          } ],
      },{
          id: 'gruz',
          label: 'Для Грузовых',
          children: [ {
            id: "D2",
            label: "D2 - (349x175x235)",
          }, {
            id: "D3",
            label: "D3 - (345x173x284)",
          }, {
            id: "D4",
            label: "D4 - (513x189x223)",
          }, {
            id: "D5",
            label: "D5 - (513x223x220)",
          }, {
            id: "D6",
            label: "D6 - (518x276x240)",
          } ],
      },{
          "id": "moto",
          "label": "Мотоциклетные",
          "children": [
            {
              "id": "YTX4L-BS",
              "label": "YTX4L-BS"
            },
            {
              "id": "YB9-B",
              "label": "YB9-B"
            },
            {
              "id": "YTX24HL",
              "label": "YTX24HL"
            },
            {
              "id": "YTX12-BS",
              "label": "YTX12-BS"
            },
            {
              "id": "YB14L-A2",
              "label": "YB14L-A2"
            },
            {
              "id": "YT19BL-BS",
              "label": "YT19BL-BS"
            },
            {
              "id": "YTX16-BS",
              "label": "YTX16-BS"
            },
            {
              "id": "53030",
              "label": "53030"
            },
            {
              "id": "YB14-A2",
              "label": "YB14-A2"
            },
            {
              "id": "YB12A-A",
              "label": "YB12A-A"
            },
            {
              "id": "YT12B-BS",
              "label": "YT12B-BS"
            },
            {
              "id": "YB10L-B2",
              "label": "YB10L-B2"
            },
            {
              "id": "YTZ14S",
              "label": "YTZ14S"
            },
            {
              "id": "YTX7L-BS",
              "label": "YTX7L-BS"
            },
            {
              "id": "YB30L-B",
              "label": "YB30L-B"
            },
            {
              "id": "6N4-2A",
              "label": "6N4-2A"
            },
            {
              "id": "YB5L-B",
              "label": "YB5L-B"
            },
            {
              "id": "YTX20-BS",
              "label": "YTX20-BS"
            },
            {
              "id": "YTR4A-BS",
              "label": "YTR4A-BS"
            },
            {
              "id": "YT9B-BS",
              "label": "YT9B-BS"
            },
            {
              "id": "YT7B-BS",
              "label": "YT7B-BS"
            },
            {
              "id": "YB4L-B",
              "label": "YB4L-B"
            },
            {
              "id": "YB3L-A",
              "label": "YB3L-A"
            },
            {
              "id": "YB16B-A",
              "label": "YB16B-A"
            },
            {
              "id": "YB16AL-A2",
              "label": "YB16AL-A2"
            },
            {
              "id": "YB12AL-A",
              "label": "YB12AL-A"
            },
            {
              "id": "Y60-N24-A",
              "label": "Y60-N24-A"
            },
            {
              "id": "YTX14L-BS",
              "label": "YTX14L-BS"
            },
            {
              "id": "YT14B-BS",
              "label": "YT14B-BS"
            },
            {
              "id": "YB16CL-B",
              "label": "YB16CL-B"
            },
            {
              "id": "YB16-B",
              "label": "YB16-B"
            },
            {
              "id": "YB14A-A2",
              "label": "YB14A-A2"
            },
            {
              "id": "12N5.5-3B",
              "label": "12N5.5-3B"
            },
            {
              "id": "6N11A-1B",
              "label": "6N11A-1B"
            },
            {
              "id": "YB16L",
              "label": "YB16L"
            },
            {
              "id": "6N6-3B",
              "label": "6N6-3B"
            },
            {
              "id": "6N2-2A",
              "label": "6N2-2A"
            },
            {
              "id": "YB30CL-B",
              "label": "YB30CL-B"
            },
            {
              "id": "YB7C-A",
              "label": "YB7C-A"
            },
            {
              "id": "B49-6",
              "label": "B49-6"
            },
            {
              "id": "12N5.5A-3B",
              "label": "12N5.5A-3B"
            },
            {
              "id": "6N4B-2A",
              "label": "6N4B-2A"
            },
            {
              "id": "YTZ12S",
              "label": "YTZ12S"
            },
            {
              "id": "YTX15L-BS",
              "label": "YTX15L-BS"
            },
            {
              "id": "YB7B-B",
              "label": "YB7B-B"
            },
            {
              "id": "B38-6A",
              "label": "B38-6A"
            },
            {
              "id": "AGM12-7F",
              "label": "AGM12-7F"
            },
            {
              "id": "12N5-4B",
              "label": "12N5-4B"
            },
            {
              "id": "6N12A-2D",
              "label": "6N12A-2D"
            },
            {
              "id": "6N2A-2C",
              "label": "6N2A-2C"
            },
            {
              "id": "YTZ7S",
              "label": "YTZ7S"
            },
            {
              "id": "YTX24HL-BS",
              "label": "YTX24HL-BS"
            },
            {
              "id": "YT20L-4",
              "label": "YT20L-4"
            },
            {
              "id": "YIX30L-BS",
              "label": "YIX30L-BS"
            },
            {
              "id": "YB30L-BS",
              "label": "YB30L-BS"
            },
            {
              "id": "YB5L-BS",
              "label": "YB5L-BS"
            },
            {
              "id": "Tesla",
              "label": "Tesla"
            },
            {
              "id": "Добавить",
              "label": "Добавить"
            },
            {
              "id": "YTZ14S-BS",
              "label": "YTZ14S-BS"
            },
            {
              "id": "YTZ12S-BS",
              "label": "YTZ12S-BS"
            },
            {
              "id": "YTZ10S-BS",
              "label": "YTZ10S-BS"
            },
            {
              "id": "YTZ10S",
              "label": "YTZ10S"
            },
            {
              "id": "YTZ7S-BS",
              "label": "YTZ7S-BS"
            },
            {
              "id": "YTX20СH-BS",
              "label": "YTX20СH-BS"
            },
            {
              "id": "YTX20H-BS",
              "label": "YTX20H-BS"
            },
            {
              "id": "YTX20",
              "label": "YTX20"
            },
            {
              "id": "YTX4L-B",
              "label": "YTX4L-B"
            },
            {
              "id": "YT14B-4",
              "label": "YT14B-4"
            },
            {
              "id": "YT12A-BS",
              "label": "YT12A-BS"
            },
            {
              "id": "YT7B-4",
              "label": "YT7B-4"
            },
            {
              "id": "YB19L-BS",
              "label": "YB19L-BS"
            },
            {
              "id": "YB16L-BS",
              "label": "YB16L-BS"
            },
            {
              "id": "12N5-3B",
              "label": "12N5-3B"
            },
            {
              "id": "YTX7A-BS",
              "label": "YTX7A-BS"
            },
            {
              "id": "YTX9-BS",
              "label": "YTX9-BS"
            },
            {
              "id": "YTX20L-BS",
              "label": "YTX20L-BS"
            },
            {
              "id": "YTX5L-BS",
              "label": "YTX5L-BS"
            },
            {
              "id": "YTX14-BS",
              "label": "YTX14-BS"
            },
            {
              "id": "YB9L-A2",
              "label": "YB9L-A2"
            }
          ]
        }



      ],
    };
  },
  watch: {
    'selectionLink'(newVal) {
                   
                    this.getPopularBatteries();
                  },
  products: {
    handler() {
      this.evenOnly = this.computedProducts;
    },
    deep: true
  }
},
 computed: {
  isRukovodstvoRole() {
      const u = this.$store.state.user;
      if (!u) return false;
      return String(u.role || '').toLowerCase().includes('руководство');
    },
  hasPopularBatteries() {
      const b = this.popularBatteries;
      return (
        b.exact && b.exact.products && b.exact.products.length > 0 ||
        b.similar && b.similar.products && b.similar.products.length > 0 ||
        b.model && b.model.products && b.model.products.length > 0
      );
    },
 ...mapState('savedFormsModule', ['savedForms']),
    // Проверка на наличие хотя бы одного сохраненного заказа
    hasSavedOrders() {
      return this.savedForms.length > 0;
      //console.log(this.savedForms.id);
    },
    
    // Получаем товары из активного заказа (сохраненного или временного)
    activeOrderProducts() {
      if (this.hasSavedOrders) {
        const savedOrderId = this.savedForms[0].id;
        return this.$store.getters.getProductsByOrderId(savedOrderId);
      }
      return this.$store.getters.getProductsByOrderId('temp');
    },
    
    // ID активного заказа
    activeOrderId() {
      return this.hasSavedOrders ? this.savedForms[0].id : 'temp';
    },
 
    categoryFilters() {
      return this.categoryFilter;
    },
   
    computedProducts() {
      let products = this.products;
      

      // Сортировка
      /*if (this.currentSort) {
        products = products.sort((a, b) => {
          const modifier = this.currentSortDir === 'desc' ? -1 : 1;
          if (typeof a[this.currentSort] === 'string') {
            return a[this.currentSort].localeCompare(b[this.currentSort]) * modifier;
          }
          return (a[this.currentSort] - b[this.currentSort]) * modifier;
        });
      }*/

      return products;
    }
     
}
,
  methods: {
   getFilteredCategories() {
  // Инициализируем массив для всех категорий, которые нужно включить в фильтр
  let filteredCategories = [...this.categories];

  // Получаем списки дочерних категорий для групп "Наши магазины" и "Поставщики"
  const ourStores = this.categoryFilters.find(cat => cat.id === 'm').children.map(child => child.id);
  const suppliers = this.categoryFilters.find(cat => cat.id === 'm-2').children.map(child => child.id);

  // Проверяем, выбрана ли группа "Наши магазины" (id: 'm') или хотя бы один склад из этой группы
  if (this.categories.includes('m') || this.categories.some(category => ourStores.includes(category))) {
    filteredCategories.push('m');
    filteredCategories = filteredCategories.concat(ourStores);
  }

  // Проверяем, выбрана ли группа "Поставщики" (id: 'm-2') или хотя бы один склад из этой группы
  if (this.categories.includes('m-2') || this.categories.some(category => suppliers.includes(category))) {
    filteredCategories.push('m-2');
    filteredCategories = filteredCategories.concat(suppliers);
  }

  // Удаляем дубликаты и возвращаем уникальный список категорий
  return [...new Set(filteredCategories)];
}
,
   // Метод для добавления товара в заказ
  emitAddProduct(product, quantity = 1) {
    const existingProduct = this.activeOrderProducts.find(p => p.id === product.id);
    if (existingProduct) {
        this.$store.commit('updateProductQuantity', { orderId: this.activeOrderId, productId: product.id, quantity: existingProduct.quantity + quantity });
        this.lastAddedProductId = product.id;
        this.updateButtonPosition();
    } else {
        this.$store.commit('addProduct', { 
            orderId: this.activeOrderId,
            product: {
                ...product, 
                quantity, 
                originalPrice: product.price,
                displayPrice: product.price,
                total: product.price * quantity 
            }
        });
        this.lastAddedProductId = product.id;
        this.updateButtonPosition();
        console.log(this.lastAddedProductId);
    }
},

updateButtonPosition() {
  this.$nextTick(() => {
    const row = this.$refs.lastAddedProductRow && this.$refs.lastAddedProductRow[0];
    const wrapper = this.$refs.tableWrapper;

    if (row && wrapper) {
      const rowRect = row.getBoundingClientRect();
      const wrapperRect = wrapper.getBoundingClientRect();
      
      this.buttonPositionTop = rowRect.top - wrapperRect.top;
      this.buttonPositionLeft = wrapperRect.width + 10; // Справа от таблицы
      this.showCreateOrderButton = true;
    }
  });
}
,

 ...mapActions({
      // Подключение экшенов из модуля savedFormsModule
      loadSavedForms: "savedFormsModule/loadSavedForms",
      saveForm: "savedFormsModule/saveForm",
      deleteForm: "savedFormsModule/deleteForm",

      // Подключение экшенов из модуля sourceModule
      addPhoneTrunk: "sourceModule/addPhoneTrunk", // Добавление phone -> trunk
    }),

 async getPopularBatteries() {
  if (!this.selectionLink) return;

  this.loadingPopularBatteries = true;

  try {
    const response = await fetch(`${ORDERS_API_BASE}/popular-batteries.php?link=${encodeURIComponent(this.selectionLink)}`);
    const result = await response.json();

    if (result.success) {
      this.popularBatteries = result.batteries;
    } else {
      console.error('Ошибка получения популярных товаров:', result.message);
    }
  } catch (error) {
    console.error('Ошибка запроса:', error);
  } finally {
    this.loadingPopularBatteries = false;
  }
}
,

generateUniqueId() {
      return Math.floor(Date.now() / 1000);
    },

 async newOrder() {
  const formId = this.generateUniqueId();

  // Формируем объект данных формы
  const formOrder = {
    order: {
      id: formId,
      orderType: {label: "Физическое лицо", value: "eshop-individual"},
      site: {label: "Центральный офис 1akb.by", value: "1akb-by"},
      /*managerId: {
        label: this.user.label, // Передаём label
        value: this.user.id, // Передаём value
      },*/
      orderMethod: {},
      contragent:{
        contragentType:{ label: 'Физическое лицо', value: 'individual' },
      },
      
      
      products: [], // Пустой массив продуктов
      comments: {
        customerComment: '',
        managerComment: '',
      },
      shipment: {
        shipmentDate: null,
        deliveryCost: null,
        deliveryAddress: '',
        deliveryDate: null,
        weight: null,
        dimensions: {
          length: null,
          width: null,
          height: null,
        },
      },
      deliveryTime: {
        from: null,
        to: null,
      },
      customTime: null,
      oneTimeDiscountAmount: null,
      oneTimeDiscountPercent: null,
      customFields: {
        manager: {
          label: this.user.label,
          value: this.user.symbolicCode
        }
      }
    }
  };

  // Сохраняем форму через Vuex
  //this.saveForm(formData);
  try {
                    const response = await axios.post(ORDERS_API_BASE + '/saveCallOrder.php', formOrder);
                        if (response.data.success) {
                            const { orderId, numberOrder, orderSite, orderCreated } = response.data;
                            
                            // Перемещаем товары из временного хранилища в новый заказ (только если это был temp)
                            if (this.activeOrderId === 'temp' && this.activeOrderProducts.length > 0) {
                                this.$store.commit('setProducts', { 
                                    orderId: orderId, 
                                    products: [...this.activeOrderProducts] 
                                });
                                // Очищаем временное хранилище
                                this.$store.commit('clearProducts', 'temp');
                            }
                            
                            const formData = { id:orderId, idorder:orderId, number:numberOrder, site: orderSite ? orderSite : {label: "Центральный офис 1akb.by", value: "1akb-by"}, created:orderCreated, orderMethod:{label:null,value: null}};
                            this.loading = false;
                            alert('Заказ успешно создан!');
                            this.$store.dispatch('savedFormsModule/clearSavedForms');
                            this.saveForm(formData);
                            this.showCreateOrderButton = false; // Скрываем кнопку
                            this.$router.push({ name: 'OrderEdit', params: { orderId, site: orderSite } });
                        } else {
                            this.loading = false;
                            alert('Ошибка при создании заказа: ' + response.data.message);
                        }
                    } catch (error) {
                        console.error('Ошибка при создании заказа:', error);
                        alert('Произошла ошибка при создании заказа.');
                        this.loading = false;
                    }
  /*console.log(
    `Форма с номером телефона ${phone} успешно сохранена. Источник: ${source.label} (${source.value})`
  );*/
},


  // Увеличение количества товара
increaseQuantity(product) {
    const existingProduct = this.activeOrderProducts.find(p => p.id === product.id);
    if (existingProduct) {
        const newQuantity = existingProduct.quantity + 1;
        this.$store.commit('updateProductQuantity', { orderId: this.activeOrderId, productId: product.id, quantity: newQuantity });
    }
},

// Уменьшение количества товара
decreaseQuantity(product) {
    const existingProduct = this.activeOrderProducts.find(p => p.id === product.id);
    if (existingProduct) {
        if (existingProduct.quantity > 1) {
            const newQuantity = existingProduct.quantity - 1;
            this.$store.commit('updateProductQuantity', { orderId: this.activeOrderId, productId: product.id, quantity: newQuantity });
        } else {
            // Если количество становится 1 и уменьшается, удаляем товар из заказа
            this.$store.commit('removeProduct', { orderId: this.activeOrderId, productId: product.id });
            if (this.activeOrderProducts.length === 0) {
                this.showCreateOrderButton = false;
            }
        }
    }
},

  // Проверка, добавлен ли товар в заказ
  isProductInOrder(productId) {
    return !!this.activeOrderProducts.find(product => product.id === productId);
  },

  // Получение количества товара
  getQuantity(product) {
    const existingProduct = this.activeOrderProducts.find(p => p.id === product.id);
    return existingProduct ? existingProduct.quantity : 0;
  }
,

updateItemsPerPage() {
    this.currentPage = 1; // Сбрасываем на первую страницу
    this.$store.dispatch('savePerPage', this.perPage); // Сохраняем в Vuex
    this.fetchProducts(); // Загружаем данные с обновленным количеством элементов
    console.log(this.$store.getters.getPerPage);
  },

selectStores(type) {
    // Сбрасываем другие чекбоксы при выборе одного из вариантов
    if (type === 'minsk') {
      this.ourStoresChecked = false;
      this.suppliersChecked = false;
      this.karvataChecked = false;
      this.vputiChecked = false;
    }else if(type === 'karvata') {
      this.minskChecked = false;
      this.ourStoresChecked = false;
      this.suppliersChecked = false;
      this.vputiChecked = false;
    }else if (type === 'ourStores') {
      this.karvataChecked = false;
      this.minskChecked = false;
      this.suppliersChecked = false;
      this.vputiChecked = false;
    }
    else if (type === 'vputi') {
      this.karvataChecked = false;
      this.minskChecked = false;
      this.ourStoresChecked = false;
      this.suppliersChecked = false;
    } 
    else if (type === 'suppliers') {
      this.karvataChecked = false;
      this.minskChecked = false;
      this.ourStoresChecked = false;
      this.vputiChecked = false;
    }

    // Обновляем `categories` на основе выбранного чекбокса
    if (this.minskChecked) {
      // Если выбран "Минск", добавляем только магазины Минска
      this.categories = this.storeGroups.minsk;
    }else if (this.karvataChecked) {
      // Если выбран "Минск", добавляем только магазины Минска
      this.categories = this.storeGroups.karvata;
    }else if (this.vputiChecked) {
      // Если выбран "Минск", добавляем только магазины Минска
      this.categories = this.storeGroups.vputi;
    } else if (this.ourStoresChecked) {
      // Если выбраны "Наши склады", добавляем только идентификатор `m`
      this.categories = ['m'];
    } else if (this.suppliersChecked) {
      // Если выбраны "Поставщики", добавляем `m` и `m-2`
      this.categories = ['m', 'm-2'];
    } else {
      // Сбрасываем `categories`, если ничего не выбрано
      this.categories = [];
    }

    // Проверяем, если все чекбоксы сняты и нет категорий, то скрываем кнопку "Сброс"
    this.filtersApplied = this.minskChecked || this.karvataChecked || this.ourStoresChecked || this.suppliersChecked || this.categories.length > 0;

    // Отправляем запрос на сервер с обновленными параметрами фильтра
    this.fetchProducts();
  },
  getSelectedStores() {
        const selectedStores = this.categories; // Это массив выбранных значений из фильтра по складам
        const selectedStoreIds = new Set();

        // Проверка выбора
        selectedStores.forEach((id) => {
            // Если выбран целый раздел (например, 'm' для магазинов, 'm-2' для поставщиков)
            const group = this.categoryFilter.find(group => group.id === id);

            if (group && group.children) {
                // Добавляем все дочерние элементы
                group.children.forEach(child => selectedStoreIds.add(child.id));
            } else {
                // Добавляем отдельно выбранные элементы
                selectedStoreIds.add(id);
            }
        });

        return Array.from(selectedStoreIds);
    },
  getSelectedCorpusTypes() {
        const selectedCorpus = this.corpus; // Это массив выбранных значений из фильтра
        const selectedIds = new Set();

        // Проверка выбора
        selectedCorpus.forEach((id) => {
            // Если выбран целый раздел (например, 'auto', 'aziat' и т.д.)
            const group = this.corpusFilter.find(group => group.id === id);

            if (group && group.children) {
                // Добавляем все дочерние элементы
                group.children.forEach(child => selectedIds.add(child.id));
            } else {
                // Добавляем отдельно выбранные элементы
                selectedIds.add(id);
            }
        });

        return Array.from(selectedIds);
    },

    //переписанные фильтры


  /*  applyFilters() {
      this.currentPage = 1;
      this.fetchProducts();
      this.filtersApplied = true; // Устанавливаем флаг, что фильтры были применены
    },*/

 copyProductName(name) {
      // Копируем order.number и устанавливаем id для показа тултипа
      navigator.clipboard.writeText(name.toString())
        .then(() => {
          this.copiedId = name;
          // Скрываем тултип через 2 секунды
          setTimeout(() => {
            this.copiedId = null;
          }, 2000);
        })
        .catch(err => {
          console.error("Ошибка копирования номера:", err);
        });
    },
applyFilters() {
  // Сохраняем текущие параметры фильтров в Vuex
  this.$store.dispatch('saveFilters', {
    keyword: this.keyword,
    lengthFrom: this.lengthFrom,
    lengthTo: this.lengthTo,
    widthFrom: this.widthFrom,
    widthTo: this.widthTo,
    heightFrom: this.heightFrom,
    heightTo: this.heightTo,
    capacityFrom: this.capacityFrom,
    capacityTo: this.capacityTo,
    priceFrom: this.priceFrom,
    priceTo: this.priceTo,
    sizes: this.sizes,
    pricekat: this.pricekat,
    brends: this.brends,
    namekat: this.namekat,
    corpus: this.corpus,
    vyzkostf: this.vyzkostf,
    categories: this.categories,
    minskChecked: this.minskChecked,
    karvataChecked: this.karvataChecked,
    ourStoresChecked: this.ourStoresChecked,
    suppliersChecked: this.suppliersChecked,
  });

  // Сохраняем текущую страницу в Vuex
  this.$store.dispatch('saveCurrentPage', 1);

  // Сбрасываем на первую страницу и обновляем данные
  this.currentPage = 1;
  this.fetchProducts();

  // Устанавливаем флаг, что фильтры были применены
  this.filtersApplied = true;
},






/*
  resetFilters() {
  // Сбрасываем все фильтры и состояние чекбоксов
  this.keyword = '';
  this.lengthFrom = '';
  this.lengthTo = '';
    this.priceFrom = '';
  this.priceTo = '';
  this.widthFrom = '';
  this.widthTo = '';
  this.heightFrom = '';
  this.heightTo = '';
  this.capacityFrom = '';
  this.capacityTo = '';
  this.pricekat = [];
  this.namekat = [];
  this.sizes = [];
  this.categories = [];
  this.corpus = [];
  this.brends = [];
  this.vyzkostf = [];
  
  // Сбрасываем состояние всех чекбоксов
  this.minskChecked = false;
  this.ourStoresChecked = false;
  this.suppliersChecked = false;

  // Устанавливаем флаг, что фильтры сброшены
  this.filtersApplied = false;
  this.currentPage = 1;

  // Перезагружаем данные
  this.fetchProducts();
},*/

resetFilters() {
  // Сбрасываем все фильтры и чекбоксы
  this.keyword = '';
  this.lengthFrom = '';
  this.lengthTo = '';
  this.priceFrom = '';
  this.priceTo = '';
  this.widthFrom = '';
  this.widthTo = '';
  this.heightFrom = '';
  this.heightTo = '';
  this.capacityFrom = '';
  this.capacityTo = '';
  this.pricekat = [];
  this.namekat = [];
  this.sizes = [];
  this.categories = [];
  this.corpus = [];
  this.brends = [];
  this.vyzkostf = [];

  // Сбрасываем состояние всех чекбоксов
  this.minskChecked = false;
  this.vputiChecked = false;
  this.karvataChecked = false;
  this.ourStoresChecked = false;
  this.suppliersChecked = false;

  // Сохраняем сброшенные значения в Vuex
  this.$store.dispatch('saveFilters', {
    keyword: '',
    lengthFrom: '',
    lengthTo: '',
    priceFrom: '',
    priceTo: '',
    widthFrom: '',
    widthTo: '',
    heightFrom: '',
    heightTo: '',
    capacityFrom: '',
    capacityTo: '',
    pricekat: [],
    namekat: [],
    sizes: [],
    brends: [],
    categories: [],
    corpus: [],
    vyzkostf: [],
    minskChecked: false,
    karvataChecked: false,
    ourStoresChecked: false,
    suppliersChecked: false,
  });

  // Сбрасываем текущую страницу в Vuex
  this.$store.dispatch('saveCurrentPage', 1);

  // Устанавливаем флаг, что фильтры сброшены
  this.filtersApplied = false;

  // Возвращаемся на первую страницу
  this.currentPage = 1;

  // Перезагружаем данные
  this.fetchProducts();
},




/*
  fetchProducts() {
  this.isLoadingMore = true;
  // Получаем все типы корпусов, которые должны участвовать в фильтрации
  const selectedCorpusTypes = this.getSelectedCorpusTypes();
  
  this.localLoading = true;

  // Проверка и логирование значений
  console.log('Текущие значения фильтров:');
  console.log('keyword:', this.keyword);
  console.log('lengthFrom:', this.lengthFrom);
  console.log('lengthTo:', this.lengthTo);
  console.log('widthFrom:', this.widthFrom);
  console.log('widthTo:', this.widthTo);
  console.log('heightFrom:', this.heightFrom);
  console.log('heightTo:', this.heightTo);
  console.log('capacityFrom:', this.capacityFrom);
  console.log('capacityTo:', this.capacityTo);
  console.log('pricekat:', this.pricekat);
  

   // Проверка и извлечение правильных значений
   const selectedVyzkostf = Array.isArray(this.vyzkostf)
    ? this.vyzkostf
        .map(id => {
          const category = this.vyzkostFilter.find(cat => cat.id === id);
          return category ? category.label : null;
        })
        .filter(label => label !== null)
    : [];

   // Проверка и извлечение правильных значений
   const selectedPriceCategories = Array.isArray(this.pricekat)
    ? this.pricekat
        .map(id => {
          const category = this.priceCategoryes.find(cat => cat.id === id);
          return category ? category.label : null;
        })
        .filter(label => label !== null)
    : [];

    const selectedNameCategory = Array.isArray(this.namekat)
    ? this.namekat
        .map(selected => {
          const category = this.nameCategory.find(cat => cat.id === selected);
          return category ? category.label : null;
        })
        .filter(label => label !== null)
    : [];

  const selectedPolarity = Array.isArray(this.sizes)
    ? this.sizes
        .map(selected => {
          const category = this.sizeFilter.find(cat => cat.id === selected);
          return category ? category.label : null;
        })
        .filter(label => label !== null)
    : [];

console.log('Выбранные категории:', selectedNameCategory);

  const params = {
    stores: this.getSelectedStores(),
    sortField: this.currentSort, 
    sortDirection: this.currentSortDir,
    keyword: this.keyword,
    sizes: selectedPolarity,
    priceFrom: this.priceFrom,
    priceTo: this.priceTo,
    lengthFrom: this.lengthFrom,
    lengthTo: this.lengthTo,
    widthFrom: this.widthFrom,
    widthTo: this.widthTo,
    heightFrom: this.heightFrom,
    heightTo: this.heightTo,
    capacityFrom: this.capacityFrom,
    capacityTo: this.capacityTo,
    pricekat: selectedPriceCategories,
    namecat: selectedNameCategory,
    vyzkostf:selectedVyzkostf,
    corpusTypes: selectedCorpusTypes, // Добавляем отфильтрованные значения
    
    page: this.currentPage,
    perPage: this.perPage
  };

  console.log('Параметры запроса:', JSON.stringify(params));

  axios.get(ORDERS_API_BASE + '/product.php', { params })
    .then(response => {
      this.products = response.data.items;
      this.totalRows = response.data.total;
      this.localLoading = false;
      this.isLoadingMore = false;
    })
    .catch(error => {
      console.error("Ошибка при загрузке данных:", error);
      this.localLoading = false;
      this.isLoadingMore = false;
    });
},*/



fetchProducts() {
  this.isLoadingMore = true;
  this.localLoading = true;

  // Получаем типы корпусов для фильтрации
  const selectedCorpusTypes = this.getSelectedCorpusTypes();

  // Логирование текущих фильтров
  console.log('Текущие значения фильтров:');
  console.log('keyword:', this.keyword);
  console.log('lengthFrom:', this.lengthFrom);
  console.log('lengthTo:', this.lengthTo);
  console.log('widthFrom:', this.widthFrom);
  console.log('widthTo:', this.widthTo);
  console.log('heightFrom:', this.heightFrom);
  console.log('heightTo:', this.heightTo);
  console.log('capacityFrom:', this.capacityFrom);
  console.log('capacityTo:', this.capacityTo);
  console.log('pricekat:', this.pricekat);
  console.log('sort:', this.currentSortDir);

  // Преобразование данных фильтров
// Проверка и извлечение правильных значений
   const selectedVyzkostf = Array.isArray(this.vyzkostf)
    ? this.vyzkostf
        .map(id => {
          const category = this.vyzkostFilter.find(cat => cat.id === id);
          return category ? category.label : null;
        })
        .filter(label => label !== null)
    : [];

   // Проверка и извлечение правильных значений
   const selectedPriceCategories = Array.isArray(this.pricekat)
    ? this.pricekat
        .map(id => {
          const category = this.priceCategoryes.find(cat => cat.id === id);
          return category ? category.label : null;
        })
        .filter(label => label !== null)
    : [];

    const selectedNameCategory = Array.isArray(this.namekat)
    ? this.namekat
        .map(selected => {
          const category = this.nameCategory.find(cat => cat.id === selected);
          return category ? category.label : null;
        })
        .filter(label => label !== null)
    : [];

  const selectedPolarity = Array.isArray(this.sizes)
    ? this.sizes
        .map(selected => {
          const category = this.sizeFilter.find(cat => cat.id === selected);
          return category ? category.label : null;
        })
        .filter(label => label !== null)
    : [];

     const selectedBrend = Array.isArray(this.brends)
    ? this.brends
        .map(selected => {
          const category = this.brendFilters.find(cat => cat.id === selected);
          return category ? category.label : null;
        })
        .filter(label => label !== null)
    : [];


  // Параметры запроса
  const params = {
    stores: this.getSelectedStores(),
    sortField: this.currentSort,
    sortDirection: this.currentSortDir,
    keyword: this.keyword,
    sizes: selectedPolarity,
    priceFrom: this.priceFrom,
    priceTo: this.priceTo,
    lengthFrom: this.lengthFrom,
    lengthTo: this.lengthTo,
    widthFrom: this.widthFrom,
    widthTo: this.widthTo,
    heightFrom: this.heightFrom,
    heightTo: this.heightTo,
    capacityFrom: this.capacityFrom,
    capacityTo: this.capacityTo,
    pricekat: selectedPriceCategories,
    namecat: selectedNameCategory,
    vyzkostf: selectedVyzkostf,
    corpusTypes: selectedCorpusTypes,
    brends: selectedBrend,
    page: this.currentPage,
    perPage: this.perPage,
  };

  console.log('Параметры запроса:', JSON.stringify(params));

  // Выполнение запроса
  axios
    .get(ORDERS_API_BASE + '/product.php', { params })
    .then(response => {
      this.products = response.data.items;
      this.totalRows = response.data.total;

      // Сохранение состояния в Vuex
      this.$store.dispatch('saveFilters', {
        keyword: this.keyword,
        lengthFrom: this.lengthFrom,
        lengthTo: this.lengthTo,
        priceFrom: this.priceFrom,
        priceTo: this.priceTo,
        widthFrom: this.widthFrom,
        widthTo: this.widthTo,
        heightFrom: this.heightFrom,
        heightTo: this.heightTo,
        capacityFrom: this.capacityFrom,
        capacityTo: this.capacityTo,
        pricekat: this.pricekat,
        namekat: this.namekat,
        brends: this.brends,
        sizes: this.sizes,
        categories: this.categories,
        corpus: this.corpus,
        vyzkostf: this.vyzkostf,
        currentPage: this.currentPage,
        currentSort: this.currentSort,
        currentSortDir: this.currentSortDir,
      });

      this.localLoading = false;
      this.isLoadingMore = false;
    })
    .catch(error => {
      console.error('Ошибка при загрузке данных:', error);
      this.localLoading = false;
      this.isLoadingMore = false;
    });
},

 fetchManagers() {
                    axios.get(ORDERS_API_BASE + '/manager.php')
                        .then(response => {
                            this.managers = sortManagersByLabel(response.data);
                        })
                        .catch(error => {
                            console.error('Ошибка при получении менеджеров:', error);
                        });
                },



async fetchManufacturer() {
  try {
    const response = await axios.get(ORDERS_API_BASE + '/manufacturer.php');
    this.brendFilters = response.data;
    this.isDataLoaded = true; // Устанавливаем флаг после загрузки
  } catch (error) {
    console.error('Ошибка при загрузке данных:', error);
  }
},





/*
    handlePageChange(page) {
      this.currentPage = page;
      this.fetchProducts();
    },*/

handlePageChange(page) {
  this.currentPage = page;

  // Сохраняем текущую страницу в Vuex
  this.$store.dispatch('saveCurrentPage', page);

  this.fetchProducts(); // Загружаем данные для новой страницы
},







/*
    sort(field) {
      // Меняем направление сортировки, если поле уже выбрано
      if (field === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
      } else {
        this.currentSort = field;
        this.currentSortDir = 'asc';
      }
      this.fetchProducts(); // Перезагружаем данные с новыми параметрами сортировки
    },*/


sort(field) {
  // Меняем направление сортировки, если поле уже выбрано
  if (field === this.currentSort) {
    this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
  } else {
    this.currentSort = field;
    this.currentSortDir = 'asc';
  }


  // Сохраняем сортировку в Vuex
  this.$store.dispatch('saveSort', {
    currentSort: this.currentSort,
    currentSortDir: this.currentSortDir,
  });

  console.log('Текущая сортировка:', this.currentSort);
  console.log('Направление сортировки:', this.currentSortDir);

  this.fetchProducts(); // Перезагружаем данные с новыми параметрами сортировки
},



   isBlueId(id) {
    return ['Володько', 'Машинка', 'Салюты', 'Бельского'].includes(id);
  },

isKarvata(id) {
    return ['Карвата'].includes(id);
  },


    handleOrderAction() {
      if (this.hasSavedOrders && this.activeOrderProducts.length > 0) {
        // Есть сохраненный заказ с товарами - открываем его
        const existingOrderId = this.savedForms[0].id;
        this.$router.push({ name: 'OrderEdit', params: { orderId: existingOrderId } }).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            throw err;
          }
        });
      } else if (!this.hasSavedOrders && this.activeOrderProducts.length > 0) {
        // Нет сохраненного заказа, но есть товары в temp - создаем новый заказ
        this.newOrder();
      } else {
        // Обычная логика создания/открытия заказа
        this.createOrder();
      }
    },

    getButtonText() {
      if (this.hasSavedOrders && this.activeOrderProducts.length > 0) {
        return `Открыть заказ (${this.activeOrderProducts.length} товаров)`;
      } else if (!this.hasSavedOrders && this.activeOrderProducts.length > 0) {
        return `Создать заказ с ${this.activeOrderProducts.length} товарами`;
      } else if (this.hasSavedOrders) {
        return 'Открыть заказ';
      } else {
        return 'Создать заказ';
      }
    },

    createOrder() {
      if (this.hasSavedOrders) {
        console.log('есть заказ');
        // Открытие существующего заказа
        const existingOrderId = this.savedForms[0].id; // Используем первый найденный заказ
        this.$router.push({ name: 'OrderEdit', params: { orderId: existingOrderId } }).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            throw err;
          }
        });
      } else {
        // Создание нового заказа
        this.$router.push({ name: 'OrderCreate' }).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            throw err;
          }
        });
      }
    },
  updateCorpus(corpusArray) {
    this.corpus = corpusArray;  // Обновляем тип корпуса для фильтрации
  },
  updateCorpusLink(url) {
    this.selectionLink = url; // Обновляем ссылку в форме
     
  },
  toggleTooltip(index) {
    this.$set(this.tooltip_blue_map, index, !this.tooltip_blue_map[index]);
  },
 
    connectWebSocket() {
     
    },
    filteredSkladm(product) {
      if (!product.skladm) return [];

      // Если выбраны категории 'Наши магазины', добавляем их дочерние категории
      let selectedCategories = this.categories;
      if (this.categories.includes('m')) {
        const ourStores = this.categoryFilters.find(cat => cat.id === 'm').children.map(child => child.id);
        selectedCategories = selectedCategories.concat(ourStores);
      }

      // Возвращаем склады с count > 0 и фильтруем по категориям, если они выбраны
      if (this.categories.length === 0) {
        return product.skladm.filter(m => m.count > 0);
      }

      return product.skladm.filter(m => selectedCategories.includes(m.id) && m.count > 0);
    }
    ,
  getStoreEntry(product, storeId) {
    if (!product || !storeId) return null;
    const stores = this.filteredSkladm(product);
    if (!stores || !Array.isArray(stores)) return null;
    return stores.find(store => store && store.id === storeId && store.count > 0) || null;
  },
  getGroupTotals(product, groupKey) {
    if (!product || !groupKey) return { count: 0, reserve: 0 };
    const group = (this.warehouseDisplayGroups && this.warehouseDisplayGroups[groupKey]) || null;
    if (!group || !group.stores) return { count: 0, reserve: 0 };
    const stores = this.filteredSkladm(product);
    if (!stores || !Array.isArray(stores)) return { count: 0, reserve: 0 };
    return stores.reduce(
      (acc, store) => {
        if (store && group.stores.includes(store.id)) {
          const count = Number(store.count) || 0;
          const reserve = Number(store.reserve) || 0;
          acc.count += count;
          if (!isNaN(reserve) && reserve > 0) {
            acc.reserve += reserve;
          }
        }
        return acc;
      },
      { count: 0, reserve: 0 }
    );
  },
  hasGroupData(product, groupKey) {
    const totals = this.getGroupTotals(product, groupKey);
    return totals.count > 0;
  },
  getGroupLabel(product, groupKey) {
    if (!product || !groupKey) return '';
    const group = (this.warehouseDisplayGroups && this.warehouseDisplayGroups[groupKey]) || null;
    if (!group || !group.label) return '';
    const totals = this.getGroupTotals(product, groupKey);
    if (!totals) return '';
    const reserveText = totals.reserve > 0 ? ` (${totals.reserve})` : '';
    return `${group.label} - ${totals.count}${reserveText} шт...`;
  },
  toggleWarehouseGroup(productId, groupKey) {
    if (!this.warehouseGroupState[productId]) {
      this.$set(this.warehouseGroupState, productId, {});
    }
    const currentState = this.warehouseGroupState[productId][groupKey] || false;
    this.$set(this.warehouseGroupState[productId], groupKey, !currentState);
  },
  isGroupExpanded(productId, groupKey) {
    return !!(this.warehouseGroupState[productId] && this.warehouseGroupState[productId][groupKey]);
  },
  getGroupStores(product, groupKey) {
    if (!product || !groupKey) return [];
    const group = (this.warehouseDisplayGroups && this.warehouseDisplayGroups[groupKey]) || null;
    if (!group || !group.stores) return [];
    const stores = this.filteredSkladm(product);
    if (!stores || !Array.isArray(stores)) return [];
    return stores.filter(store => store && group.stores.includes(store.id));
  },
  getRemainingStores(product) {
    const stores = this.filteredSkladm(product);
    if (!stores || !Array.isArray(stores)) return [];
    const minskStores = (this.warehouseDisplayGroups && this.warehouseDisplayGroups.minsk && this.warehouseDisplayGroups.minsk.stores) || [];
    const regionsStores = (this.warehouseDisplayGroups && this.warehouseDisplayGroups.regions && this.warehouseDisplayGroups.regions.stores) || [];
    const excluded = new Set([
      'Карвата',
      ...minskStores,
      ...regionsStores
    ]);
    return stores.filter(store => store && !excluded.has(store.id));
  },
  formatStoreLabel(store) {
    if (!store) return '';
    const reserve = Number(store.reserve);
    const reserveText = !isNaN(reserve) && reserve > 0 ? ` (${reserve})` : '';
    return `${store.id} - ${store.count}${reserveText} шт.`;
  },
  filteredSkladp(product) {
  if (!product.skladp) return [];

  // Если выбраны категории 'Поставщики', добавляем их дочерние категории
  let selectedCategories = this.categories;
  if (this.categories.includes('m-2')) {
    const suppliers = this.categoryFilters.find(cat => cat.id === 'm-2').children.map(child => child.id);
    selectedCategories = selectedCategories.concat(suppliers);
  }

  // Возвращаем склады с count > 0 и фильтруем по категориям, если они выбраны
  if (this.categories.length === 0) {
    return product.skladp.filter(p => p.count > 0);
  }

  return product.skladp.filter(p => selectedCategories.includes(p.id) && p.count > 0);
}
,
    updateEvenOnly() {
      const filteredProducts = this.computedProducts;
      this.evenOnly = filteredProducts;
    },
    toggleClass() {
      this.isActive = !this.isActive;
    },
    openModal() {
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    getPriceClass(product) {
      const price = parseFloat(product.price);
      const prices = [
        product.onliner,
        product.vek,
        product.ak,
        product.stigen,
        product.rimbat
      ].map(p => parseFloat(p)).filter(p => !isNaN(p));

      if (isNaN(price)) return '';

      if (prices.length === 0) return '';

      if (prices.some(p => price > p)) return 'red_pr';
      if (prices.every(p => price < p)) return 'blue';
      if (prices.some(p => price === p)) return 'green';
      return '';
    },
    resetOptions() {
      this.sort = "none";
    },
    filterByCorpus() {
      this.$refs.carSelector.getCarEngines('model');
    },
    resetForm() {
      document.getElementById("resetForm").reset();
    },
  
    changePage(num) {
      this.currentPage += num;
    },
    dayChange() {
      this.flag = 0;
    },
    nayChange() {
      this.flag = 1;
    },
    checkScroll() {
      const scrollBottom =
        window.innerHeight + window.scrollY >= document.body.offsetHeight - 10;
      this.atPageEnd = scrollBottom;
    }
  },

  created() {
    this.connectWebSocket();
    

  
  console.log(this.$store.getters.NAME); // Должен показать массив с продуктом
  },
  async mounted() {
  // Ждём завершения загрузки данных для брендов
  await this.fetchManufacturer();
  
  const savedFilters = this.$store.getters.getFilters || {};
  const savedPage = this.$store.getters.getCurrentPage || 1;
  const savedSort = this.$store.getters.getSort || { currentSort: null, currentSortDir: 'desc' };
  this.perPage = this.$store.getters.getPerPage || 30;

  // Восстанавливаем значения фильтров
  this.keyword = savedFilters.keyword || '';
  this.lengthFrom = savedFilters.lengthFrom || '';
  this.lengthTo = savedFilters.lengthTo || '';
  this.priceFrom = savedFilters.priceFrom || '';
  this.priceTo = savedFilters.priceTo || '';
  this.widthFrom = savedFilters.widthFrom || '';
  this.widthTo = savedFilters.widthTo || '';
  this.heightFrom = savedFilters.heightFrom || '';
  this.heightTo = savedFilters.heightTo || '';
  this.capacityFrom = savedFilters.capacityFrom || '';
  this.capacityTo = savedFilters.capacityTo || '';
  this.pricekat = savedFilters.pricekat || [];
  this.namekat = savedFilters.namekat || [];
  this.sizes = savedFilters.sizes || [];
  this.brends = savedFilters.brends || [];
  this.categories = savedFilters.categories || [];
  this.corpus = savedFilters.corpus || [];
  this.vyzkostf = savedFilters.vyzkostf || [];

  // Применяем флаги для чекбоксов
  this.karvataChecked = this.categories.some(category => this.storeGroups.karvata.includes(category));
  this.minskChecked = this.categories.some(category => this.storeGroups.minsk.includes(category));
  this.ourStoresChecked = this.categories.includes('m'); // Проверяем идентификатор группы "Наши склады"
  this.suppliersChecked = this.categories.includes('m-2'); // Проверяем идентификатор группы "Поставщики"

  // Устанавливаем флаг, если хотя бы один фильтр установлен
  this.filtersApplied = Boolean(
    this.keyword ||
    this.lengthFrom ||
    this.lengthTo ||
    this.priceFrom ||
    this.priceTo ||
    this.widthFrom ||
    this.widthTo ||
    this.heightFrom ||
    this.heightTo ||
    this.capacityFrom ||
    this.capacityTo ||
    this.pricekat.length ||
    this.namekat.length ||
    this.sizes.length ||
    this.categories.length ||
    this.corpus.length ||
    this.brends.length ||
    this.vyzkostf.length
  );

  // Восстанавливаем пагинацию и сортировку
  this.currentPage = savedPage;
  this.currentSort = savedSort.currentSort;
  this.currentSortDir = savedSort.currentSortDir;


  // Если нет сохранённых категорий — активируем "Все"
  if (!this.categories.length) {
    this.suppliersChecked = true;
    this.categories = ['m', 'm-2'];
  }
  // Загрузка сохраненных заказов при монтировании компонента
  this.$store.dispatch('savedFormsModule/loadSavedForms');
  this.fetchProducts();
  this.fetchManagers();
  this.user = this.$store.state.user;

   window.addEventListener("scroll", this.checkScroll);


},
  beforeDestroy() {
    if (this.socket) {
      this.socket.close();
    }
    
    window.removeEventListener("scroll", this.checkScroll);
  }
};
</script>

<style scoped>

    body {
  color: #1e2248;
  font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,Roboto,sans-serif;
  font-size: 14px;
  line-height: 1.5;
  background: #f4f6f8;
}
        
/* Ячейка цены: старая сверху, текущая снизу */
.price-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}
.modern-table td .price-cell .price-current,
td .price-cell .price-current {
  background: transparent !important;
  padding: 0 !important;
  font-size: inherit !important;
  border: none !important;
  border-radius: 0 !important;
}
/* Старая цена — перебиваем общий td span */
.modern-table td .old-price,
td .old-price {
  color: #888;
  text-decoration: line-through;
  margin-right: 0;
  background: transparent !important;
  padding: 0 !important;
  font-size: inherit !important;
  border: none !important;
  border-radius: 0 !important;
}
.gtd-cell {
  max-width: 120px;
  font-size: 12px;
  word-break: break-word;
}
.modern-table td .gtd-value,
td .gtd-value {
  color: #1a4a7a;
  font-weight: 600;
  background: transparent !important;
  padding: 0 !important;
  border: none !important;
}
.gtd-empty {
  color: #adb5bd;
}
.red_pr {
  background-color: #ff000036;
}
.blue {
  background-color: #0000ff38;
}
.green {
    background-color: #00800045;
}



      .flex-podbor {
        display: flex;
    flex-wrap: wrap;
    margin-bottom: 25px;
    padding: 20px;
    background: #fff;
      }

        .main-content {
            width: 100%;
            margin: 5px;
            background: transparent;
            border-radius: 0px;
            padding-bottom: 25px;
            border-bottom: solid 1px #dee2e6;
            margin-bottom: 25px;
        }

        .vs--single .vs__selected {
          background-color: #e3f2fd;
          border-color: transparent;
          color: #23a7e8;
          font-size: 12px;
          border-radius: 0px;
        }

        .vs__dropdown-toggle {
              -webkit-appearance: none;
              -moz-appearance: none;
              appearance: none;
              display: flex;
              padding: 0 0 4px;
              background: none;
              border: 1px solid rgba(60,60,60,.26);
              border-radius: 4px;
              white-space: normal;
              background: white;
              margin-bottom: 5px;
              color: #000;
            }

      #app {
       background: #transparent;
    
    border-radius: 6px;
      }

      .flex-podbor-li {
        width: 25%;
        margin-right: 5px;
      }

      #app img {
        max-width: 38px;
      }

      .table td, .table th {
        padding: 0.25rem;
        vertical-align: top;
        border-top: 1px solid #dee2e6;
        font-size: 12px;
    }

    #resetForm {
      display: flex;
        flex-wrap: wrap;
            width: 100%;
    }

    .reset_block {
      display: flex;
        flex-direction: column;
        width: 22%;
        margin: 6px;
    }

    .vue-treeselect__control {
      border-radius: 0px!important;
    }


    

    td p {
      margin-bottom: 2px;
      font-size: 12px;
    line-height: 14px;
    margin: 2px;
    }

    td span {
      background: #f4f6f8;
   padding: 3px 7px;
    font-size: 11px;
    border: solid 1px #19191921;
    border-radius: 8px;
    }

    input[type=range] {
        box-sizing: border-box;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        width: 220px;
        margin: 0;
        padding: 0 2px;
        /* Add some L/R padding to ensure box shadow of handle is shown */
        overflow: hidden;
        border: 0;
        border-radius: 1px;
        outline: none;
        background: -webkit-linear-gradient(grey, grey) no-repeat center;
        background: linear-gradient(grey, grey) no-repeat center;
        /* Use a linear gradient to generate only the 2px height background */
        background-size: 100% 2px;
        pointer-events: none;
    }
    input[type=range]:active,
    input[type=range]:focus {
        outline: none;
    }
    input[type=range]::-webkit-slider-thumb {
        height: 28px;
        width: 28px;
        border-radius: 28px;
        background-color: #fff;
        position: relative;
        margin: 5px 0;
        /* Add some margin to ensure box shadow is shown */
        cursor: pointer;
        -webkit-appearance: none;
        appearance: none;
        pointer-events: all;
        box-shadow: 0 1px 4px 0.5px rgba(0, 0, 0, 0.25);
    }
    input[type=range]::-webkit-slider-thumb::before {
        content: ' ';
        display: block;
        position: absolute;
        top: 13px;
        left: 100%;
        width: 2000px;
        height: 2px;
    }
    .multi-range {
        position: relative;
        height: 50px;
        display: inline-block;
    }
    .multi-range input[type=range] {
        position: absolute;
    }
    .multi-range input[type=range]:nth-child(1)::-webkit-slider-thumb::before {
        background-color: red;
    }
    .multi-range input[type=range]:nth-child(2) {
        background: none;
    }
    .multi-range input[type=range]:nth-child(2)::-webkit-slider-thumb::before {
        background-color: grey;
    }

    .reset_block_two {
      display: flex;
      flex-direction: column;
      width: 45%;
      margin: 6px;
    }

    .bonus {
      background: #e4ffe4;
    margin-left: 6px;
    font-size: 10px;
    border: solid 1px #dee2e6;
    }

    .nobonus {
      background: #ff787838;
    margin-left: 6px;
    font-size: 10px;
    border: solid 1px #00000038;
    }

      @media (max-width: 970px) {
        .flex-podbor-li {
          width: 100%;
          margin-right: 0px;
          margin-bottom: 5px;
    }
      #app .primary.small {
        margin-left: 0px;
          width: 100%;
      }
      }
    .border {
    border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
    width: 100%;
    padding: 6px;
    border-radius: 4px;
}

    .BLOCK_INPUT {
        display: flex;
        justify-content: space-between;
    }

     .BLOCK_INPUT input{
        max-width: 45%;
    }

  .table thead th {
    vertical-align: top;
    border-bottom: 2px solid #f2f2f8;
    line-height: 14px;
}

.btn.btn-outline {
  background: transparent;
  border: solid 1px black;
  display: flex;
  align-items: center;
  font-size: 12px;
  margin: 6px;
}

.add-task-button .icon {
    width: 24px;
    height: 24px;
    color: var(--base-icon-secondary);
}


.add-task-button .text {
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
}


.add-task-button {
    display: flex;
    gap: 10px;
    padding: 5px 15px !important;
    color: var(--text-secondary) !important;
    letter-spacing: 0.5px;
    border-color: var(--base-secondary) !important;
}


.table-bordered td, .table-bordered th {
  border: 1px solid rgb(207 211 218 / 50%);
    border-top-color: rgba(207, 211, 218, 0.5);
    border-top-style: solid;
    border-top-width: 1px;
}

.table td, .table th {
  padding: 0.25rem;
  vertical-align: top;
  border-top: 1px solid #dee2e6;
  font-size: 12px;
}

.pagination {
  display: -ms-flexbox;
  display: flex;
  padding-left: 0;
  list-style: none;
  border-radius: .25rem;
      list-style: none;
    justify-content: center;
    margin-top: 25px;

  list-style: none;
}




.page-link {
  color: #666;
  border-bottom: 2px solid #d6d8d9;
    border-bottom-color: rgb(214, 216, 217);
}
.page-link {
  position: relative;
  display: block;
  padding: .5rem .75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #007bff;
  background-color: #fff;
  border: 1px solid #dee2e6;
    border-top-color: rgb(222, 226, 230);
    border-right-color: rgb(222, 226, 230);
    border-bottom-color: rgb(222, 226, 230);
    border-bottom-style: solid;
    border-bottom-width: 1px;
    border-left-color: rgb(222, 226, 230);
}

.page-link {
  color: #666;
  border-bottom: 2px solid #d6d8d9;
    border-bottom-color: rgb(214, 216, 217);
}


.page-link:not(:disabled):not(.disabled) {
  cursor: pointer;
}

.page-item:first-child .page-link {
  margin-left: 0;
  border-top-left-radius: .25rem;
  border-bottom-left-radius: .25rem;
}


.page-item.disabled .page-link {
  color: #6c757d;
  pointer-events: none;
  cursor: auto;
  background-color: #fff;
  border-color: #dee2e6;
}
   

.page-item.active .page-link {
  background-color: #e22719;
  border-color: #e22719;
  color: #fff;
}





.header-main {
    display: flex;
    empty-cells: hide;
    padding: 32px 0 24px;
    justify-content: space-between;
}



.hm-left {
    color: #1e2248;
    float: left;
    width: 75%;
}

.header-main .hm-left, .header-main .hm-right {
    display: table-cell;
    float: none;
    vertical-align: top;
}

.header-main .hm-left {
    width: auto;
}

.header-main .hm-left, .header-main .hm-right {
    display: table-cell;
    float: none;
    vertical-align: top;
}




.hm-left h1 {
    font-size: 24px;
    font-weight: 500;
    letter-spacing: -.3px;
    line-height: 32px;
    margin-top: 10px;
}

.header-main__title:not(:last-child) {
    margin-right: 16px;
}

.btn {
    background: none;
    background-color: #005eeb;
    background-image: linear-gradient(180deg, #0068ff, #005bd5);
    border: none;
    border-radius: 6px;
    color: #fff;
    cursor: pointer;
    display: inline-block;
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, Roboto, sans-serif;
    font-size: 14px;
    font-weight: 400;
    font-weight: 500;
    height: 27px;
    line-height: 20px;
    padding: 8px 20px;
    text-decoration: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    vertical-align: middle;
}


.btn-content:before {
    content: "";
    height: 20px;
    margin-right: 8px;
    width: 20px;
}

.btn-content_icon:before {
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: 100%;
    float: none !important;
    margin-left: 0 !important;
    top: 0 !important;
}

.btn-content_new:before {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Cpath fill='%23FFF' fill-rule='evenodd' d='M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0 0 12 2Zm0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16Zm1-9h2.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H13v2.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V13H8.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5H11V8.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5V11Z' clip-rule='evenodd'/%3E%3C/svg%3E");
}

.btn_md .btn-content_icon:before, .btn_min-icon {
    height: 24px;
    width: 24px;
}


.btn_md {
    font-size: 16px;
    height: 25px;
    line-height: 24px;
    padding: 12px 24px;
}

.btn-content_icon {
    margin-left: -8px;
}

.btn-content {
    display: flex;
}

.input_flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.input_flex span {
    margin: 0px 10px;
}

.filter-group .chosen-container-single:not(.chosen-container_inline) .chosen-single, .filter-group input[type=email], .filter-group input[type=number], .filter-group input[type=password], .filter-group input[type=text], .filter-group input[type=time], .filter-group select, .filter-group span.selectbox {
    clear: left;
    display: inline-block;
    width: 100%;
}

.m-filter .filter-group .selectbox .select, .m-filter .filter-group input[type=email], .m-filter .filter-group input[type=number], .m-filter .filter-group input[type=password], .m-filter .filter-group input[type=text], .m-filter .filter-group input[type=time], .m-filter .filter-group select {
    border: 1px solid var(--input-border-color);
    border-radius: var(--input-border-radius);
    box-shadow: var(--input-box-shadow);
    color: var(--input-color);
    font-size: var(--input-font-size);
    height: var(--input-height);
    line-height: var(--input-line-height);
    padding: var(--input-padding);
    transition: var(--input-transition);
}

.border.border-gray-200 {
  width:97%;
  height: 22px;
}

input, button, select, optgroup, textarea {
  font-size:12px;
}

.btn_ms {
margin-right: 15px;
    background: linear-gradient(180deg, #fea530, #e48e1e) !important;
    color: #ffffff;
    font-size: 16px;
    height: 25px;
    line-height: 24px;
    padding: 12px 24px;
}

.modern-table tr th {
        background: #ffffff;
    background-color: rgb(255 255 255);
    border-bottom: 1px solid #dee2e6;
    border-left: none;
    color: #636f7f;
    font-size: 11px;
    font-weight: 400;
    padding: 14px 5px;
    padding-right: 5px;
    padding-left: 5px;
    text-align: center;
    border-right: solid 1px #dee2e6;
}

.modern-table tr td {
    color: #1e2248;
    font-size: 12px;
    text-align: left;
    border-right: solid 1px #dee2e6;
    border-bottom: solid 1px #dee2e6;
    padding: 4px;
    line-height: 14px;
}

.modern-table tr:hover {
    background-color: #f9fafb;
    cursor: pointer;
}

.modern-table {
  background: #fff;
}

a {
    color: rgb(0 0 0);
    text-decoration: none;
    display: block;
}

.checkbox-wrapper {
 display: flex;
    align-items: center;
    margin: 7px;
    margin-top: 20px;
    border-top: solid 1px #dddddd;
    padding-top: 10px;
    width: 100%;
}

.checkbox-wrapper input[type="checkbox"] {
  width: 20px;
  height: 20px;
  cursor: pointer;
  accent-color: #007bff; /* Стилизация чекбокса */
}

.checkbox-wrapper label {
      margin-left: 10px;
    font-size: 12px;
    cursor: pointer;
    width: 100%;
}

.spinner {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 3px solid rgba(0, 123, 255, 0.3); /* полупрозрачная обводка */
  border-radius: 50%;
  border-top-color: #007bff; /* синяя обводка сверху */
  animation: spin 1s ease-in-out infinite;
  margin-right: 8px;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.loader-container {
  position:relative;
  background:#ffffff;
  width:100%;
  min-height:100vh;
}

.apply {
    background: none;
    background-color: #fff;
    background-image: linear-gradient(180deg, #fff, #e9ecee);
    border: 1px solid #dee2e6;
    border-radius: 6px;
    cursor: pointer;
    display: inline-block;
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, Roboto, sans-serif;
    font-size: 14px;
    font-weight: 400;
    font-weight: 500;
    height: 27px;
    line-height: 20px;
    padding: 7px 20px 8px;
    text-decoration: none;
    text-shadow: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    vertical-align: middle;
}



.apply, .apply.active, .apply:active, .apply:hover {
    color: #1e2248;
    text-decoration: none;
}

.apply, .apply:focus {
    outline: none;
}

.button_filter_block {
 width: 100%;
    padding: 6px;
    margin-top: 20px;
    display: flex;
}

.apply.text {
  display: flex;
    align-items: center;
}




.filter-cancel {
    background: none;
    background-color: #fff;
    background-image: linear-gradient(180deg, #fff, #e9ecee);
    border: 1px solid #dee2e6;
    border-radius: 6px;
    cursor: pointer;
    display: inline-block;
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, Roboto, sans-serif;
    font-size: 14px;
    font-size: 0;
    font-weight: 400;
    height: 26px;
    line-height: 20px;
    line-height: 17px;
    overflow: hidden;
    padding: 8px;
    position: relative;
    text-decoration: none;
    text-overflow: ellipsis;
    text-shadow: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    vertical-align: middle;
    white-space: nowrap;
    width: 26px;
}

.filter-cancel, .filter-cancel.active, .filter-cancel:active, .filter-cancel:hover {
    color: #1e2248;
    text-decoration: none;
}

.apply+.filter-cancel {
    margin-left: 8px;
}

.filter-cancel:before {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24'%3E%3Cpath fill='%23FF5353' d='M7.113 6.176a.6.6 0 0 1 .848 0L12 10.214l4.038-4.038a.6.6 0 0 1 .849 0l.937.937a.6.6 0 0 1 0 .848L13.785 12l4.04 4.04a.6.6 0 0 1 0 .848l-.937.937a.6.6 0 0 1-.849 0L12 13.784l-4.038 4.04a.6.6 0 0 1-.849 0l-.937-.937a.6.6 0 0 1 0-.848l4.04-4.04-4.039-4.038a.6.6 0 0 1 0-.849l.937-.936Z'/%3E%3C/svg%3E");
    background-position: 50%;
    background-repeat: no-repeat;
    bottom: 0;
    content: "";
    height: 24px;
    left: 0;
    margin: auto;
    position: absolute;
    right: 0;
    top: 0;
    width: 24px;
}

.modern-table {
  width: 100%;
  border-collapse: collapse;
}

.modern-table thead {
  position: sticky;
  top: 0; /* Фиксация в верхней части экрана */
  background-color: #ffffff; /* Цвет фона для заголовка, чтобы он перекрывал контент при прокрутке */
  z-index: 10; /* Установить приоритет, чтобы он всегда был поверх контента */
}

.modern-table thead th {
  padding: 8px;
  background-color: #ffffff; /* Можно выбрать другой цвет для заголовка */
  border-bottom: solid 1px #dee2e6;
  box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4); /* Добавление небольшого тени для разделения заголовка */
}

.modern-table tbody tr td {
  padding: 4px;
  border-bottom: 1px solid #ddd;
}

.modern-table tbody tr td img {
  max-width: 50px; /* Ограничение размера изображений */
}


td .property span {
    background: transparent;
    padding: 0px;
    font-size: 10px;
    border: solid 0px #c7b0b0;
    margin: 0px;
}

.property {
  margin-top:4px;
}

.chek_left {
  width: 100%;
    display: flex;
    align-items: center;
}

.chek_right {
  width: 100%;
    display: flex;
    align-items: center;
    justify-content: right;
}

.count {
  position: absolute;
    top: 5px;
    right: 5px;
    font-size: 10px;
    color: #6c757d;
}



.table-td-button {
  width: 40px;
}

.qty-btn, .add-btn {
    margin: 0 4px;
    padding: 8px 12px;
    font-size: 12px;
    font-weight: 500;
    border: none;
    cursor: pointer;
    color: #ffffff;
    border-radius: 5px;
    transition: background 0.3s ease;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.add-btn {
    background-color: #4CAF50 !important;
    background-image: linear-gradient(180deg, #22c993, #20a77f) !important;
    color: #fff;
    width: 67%;
}

.button_quantity {
    display: flex;
    align-items: center;
    justify-content: center;
}

.qty-btn-decrease{
    color: #000000;
    cursor: pointer;
    background-color: #fff;
    background-image: linear-gradient(180deg, #fff, #e9ecee);
    border: 1px solid #dee2e6;
    text-shadow: none;
    box-shadow: none;
    font-weight: 600;
}

.qty-btn-increase{
    color: #000000;
    cursor: pointer;
    background-color: #fff;
    background-image: linear-gradient(180deg, #fff, #e9ecee);
    border: 1px solid #dee2e6;
    text-shadow: none;
    box-shadow: none;
}

.quantity {
    background: transparent;
    padding: 0px 4px;
    font-size: 12px;
    border: solid 0px #c7b0b0;
}

.in-order-label {
    background: transparent;
    padding: 0px;
    font-size: 12px;
    border: solid 0px #c7b0b0;
    color: #ff4500;
    font-weight: bold;
    margin-left: 0px;
}

.in-order {
    background-color: #f0f8ff;
}

.table-wrapper {
  position: relative;
}

.create-order-btn {
  position: absolute;
    padding: 10px 20px;
    font-size: 16px;
    background-color: #005edf;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    margin: 0 4px;
    padding: 5px 12px;
    font-size: 12px;
    font-weight: 500;
    border: none;
    cursor: pointer;
    color: #ffffff;
    border-radius: 5px;
    transition: background 0.3s ease;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    line-height: 14px;
    z-index:9999999;
}
.create-order-btn:hover {
  opacity:.5;
}
.create-order-btn::before {
  content: "";
    position: absolute;
    left: -4px;
    top: 50%;
    transform: translateY(-50%) rotate(45deg);
    width: 10px;
    height: 10px;
    background-color: #005edf;
}

.vs__dropdown-toggle {
    border: 1px solid rgba(60, 60, 60, .26);
}

/* Дополнительный стиль для заблокированной кнопки */
.disabled {
  pointer-events: none;
  opacity: 0.5;
}

.check_right {
  display: flex;
  gap: 10px;
  align-items: center;
}

.check_right input[type="checkbox"].switch {
  display: none;
}

.check_right label {
  display: flex;
  align-items: center;
  position: relative;
  padding-left: 40px;
  cursor: pointer;
  font-size: 14px;
  white-space: nowrap;
  min-width: auto;
    max-width: 88px;
}

.check_right label::before {
  content: "";
  position: absolute;
  left: 0;
  width: 30px;
  height: 18px;
  background-color: #ccc;
  border-radius: 15px;
  transition: background-color 0.3s ease;
}

.check_right label::after {
    content: "";
    position: absolute;
    left: 2px;
    width: 13px;
    height: 13px;
    background-color: white;
    border-radius: 50%;
    transition: transform 0.3s ease;
    top: 8px;
}

.check_right input[type="checkbox"].switch:checked + label::before {
  background-color: #21ba8a;
}

.check_right input[type="checkbox"].switch:checked + label::after {
  transform: translateX(14px);
}





.chek_left input[type="checkbox"].switch {
  display: none;
}

.chek_left label {
  display: flex;
  align-items: center;
  position: relative;
  padding-left: 40px;
  cursor: pointer;
  font-size: 14px;
  white-space: nowrap;
}

.chek_left label::before {
  content: "";
  position: absolute;
  left: 0;
  width: 30px;
  height: 18px;
  background-color: #ccc;
  border-radius: 15px;
  transition: background-color 0.3s ease;
}

.chek_left label::after {
    content: "";
    position: absolute;
    left: 2px;
    width: 13px;
    height: 13px;
    background-color: white;
    border-radius: 50%;
    transition: transform 0.3s ease;
    top: 8px;
}

.chek_left input[type="checkbox"].switch:checked + label::before {
  background-color: #21ba8a;
}

.chek_left input[type="checkbox"].switch:checked + label::after {
  transform: translateX(14px);
}

.items-per-page-selector {
      display: flex;
    align-items: center;
}

.items-per-page-selector label {
  width: auto;
    min-width: 87px;
}

.apply.text .spinner {
  margin-top: 0px;
}

.add-btn:hover {
  opacity: .7;
}

.icon-truck {
  display: inline-block;
  width: 16px;
  height: 16px;
  background-image: url("/path/to/truck-icon.svg"); 
  background-size: cover;
  margin-right: 4px;
}

.tooltip-container {
  display: inline-flex;
  align-items: center;
}

.btntask {
  margin-right: 15px !important;
  background:  #f86d6d !important;
}

.blue-text {
  background: #baddba;
    color: #2a4f2afc;
    border-color: #2a4f2a4f;
  }

.tooltip-wrapper {
  position: relative;
  cursor: pointer;
  display: inline-block;
}

.green-karvata {
 color: #039be5;
    background: #e3f2fd;
    border-color: #76c7ee;
}

.tooltip-content {
  display: none;
  position: absolute;
  bottom: 125%; /* позиция над текстом */
  left: 50%;
  transform: translateX(-50%);
  background-color: #333;
  color: #fff;
  padding: 6px 10px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  z-index: 10;
  opacity: 0;
  transition: opacity 0.2s;
}

.tooltip-wrapper:hover .tooltip-content {
  display: block;
  opacity: 1;
}

/* Стрелочка */
.tooltip-arrow {
  position: absolute;
  top: 100%; /* стрелка снизу тултипа */
  left: 50%;
  margin-left: -5px;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #333;
  background: transparent;
  padding: 0px;
}

.warehouse-item {
  padding: 3px 7px;
  font-size: 11px;
  border: solid 1px #19191921;
  border-radius: 8px;
  margin: 2px;
  display: inline-block;
  transition: all 0.3s ease;
}

.warehouse-item:hover {
  border-color: #19191940;
  background-color: #f0f0f0;
  transition: all 0.2s ease;
}

.warehouse-group-toggle {
  cursor: pointer;
  user-select: none;
  transition: all 0.3s ease;
}

.warehouse-group-toggle:hover {
  opacity: 0.8;
  border-color: #19191960;
  transition: all 0.2s ease;
}

.warehouse-group-details {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.btn-show-batteries {
 
  position: relative;
  top: 0px;
  right: 0;
  left: 0px;
}

.copy-btn {
  background: none;
  border: none;
  cursor: pointer;
  margin-left: 5px;
  padding: 0;
}

.fa-copy svg {
  width: 17px;
  height: 17px;
  opacity: .5;
}


.tooltips {
  position: absolute;
  top: -40px; /* Расстояние от кнопки, можно настроить */
  left: 50%;
  transform: translateX(-50%);
  background: #333;
  color: #fff;
  padding: 5px 10px;
  font-size: 12px;
  border-radius: 4px;
  white-space: nowrap;
  z-index: 10;
}

.tooltips-arrow {
  position: absolute;
  bottom: -5px; /* Расположение стрелочки под тултипом */
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #333;
}


.fixedPagination {
    position: fixed;
    bottom: 0;
    left: 50%;
    right: 50%;
    display: flex;
    justify-content: center;
}

.fixedPagination .btn:hover {
  background: #215282;
  opacity: 1;
}

.staticPagination {
    position: relative;
    display: flex;
    justify-content: center;
    left: 20px;
}

</style>


<style>
.vue-treeselect__placeholder {
  font-size:12px;
}



</style>